import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import Dialog from '@components/shared/Dialog'
import { TitleContext } from '@providers/TitleProvider'
import TitleService from '@services/TitleService'
import { useDialogStore } from '@stores/dialog.store'

const CreateEditableCopyDialog: React.FC = () => {
  const { t } = useTranslation()
  const { title } = useContext(TitleContext)
  const closeDialog = useDialogStore((s) => s.closeDialog)

  const createEditableCopy = async () => {
    await TitleService.createEditableCopy(title.uuid)
    closeDialog('create_editable_copy')
  }

  return (
    <Dialog name="create_editable_copy" maxWidth={364} title={t('content.copyToEditor')}>
      <p className="mb-3">{t('content.copyToEditorInstructions')}</p>
      <Button
        variant="primary"
        className="text-md px-2 py-1.5 float-right"
        onClick={createEditableCopy}>
        {t('action.copyToEditor')}
      </Button>
    </Dialog>
  )
}

export default CreateEditableCopyDialog
